import React, { useState } from "react";
import PharmacyBillingPanel from "./PharmacyBillingPanel";
import StockEntryPanel from "./StockEntryPanel";
import PharmacySuppliersPanel from "./PharmacySuppliersPanel";
import PharmacySalesHistoryPanel from "./PharmacySalesHistoryPanel";
import DrugListPanel from "./DrugListPanel";
import StockChartPanel from "./StockChartPanel";
import PharmacyLettersPanel from "./PharmacyLettersPanel";
import PharmacyModuleHeader, { type PharmacyModuleTab } from "./PharmacyModuleHeader";
import DrugSupplierNotesPanel from "./DrugSupplierNotesPanel";
import AppShellLayout from "../layout/AppShellLayout";
import "./ModernPharmacy.css"; // UPDATED IMPORT

export default function PharmacyDashboard() {
  const [activeTab, setActiveTab] = useState<PharmacyModuleTab>("billing");

  return (
    <AppShellLayout
      moduleId="pharmacy"
      header={(
        <PharmacyModuleHeader
          activeTab={activeTab}
          onSelectTab={setActiveTab}
        />
      )}
      left={undefined}
      leftCollapsible={false}
      main={(
          <div className="pharmacy-main">
            {activeTab === "billing" && (
              <div className="fade-in-up">
                <PharmacyBillingPanel onOpenSalesHistory={() => setActiveTab("collection")} />
              </div>
            )}

            {activeTab === "collection" && (
              <div className="fade-in-up">
                <PharmacySalesHistoryPanel />
              </div>
            )}

            {activeTab === "suppliers" && (
              <div className="fade-in-up">
                <PharmacySuppliersPanel />
              </div>
            )}

          {activeTab === "stock" && (
            <div className="stock-inventory-layout fade-in-up">
              <div className="stock-main-content">
                <StockEntryPanel />
              </div>
              <div className="stock-right-panel">
                <DrugListPanel />
              </div>
              <div className="stock-bottom-panel">
                <StockChartPanel />
              </div>
            </div>
          )}

          {activeTab === "letters" && (
            <div className="fade-in-up">
              <PharmacyLettersPanel />
            </div>
          )}

          {activeTab === "notes" && (
            <div className="fade-in-up">
              <DrugSupplierNotesPanel />
            </div>
          )}
        </div>
      )}
    />
  );
}
